import { get /*, post, put */ } from "./axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL; //"http://kube-w1:32751/api";

class DashboardApi {
  static getOfferStats() {
    return get(url + "/dashboard/offerstats");
  }

  static getActiveContractChartData() {
    return get(url + "/dashboard/ActiveContractChartData");
  }

  static getAverageTimeStates() {
    return get(url + "/dashboard/averageTimeStates");
  }

  static getActivities() {
    return get(url + "/dashboard/activities");
  }
}

export default DashboardApi;
